import React from 'react';
const BotonInfoGeneral = props => (
  <svg
    width="19"
    height="23"
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1.92578C7 1.3735 7.44772 0.925781 8 0.925781H11C11.5523 0.925781 12 1.3735 12 1.92578V21.9258C12 22.4781 11.5523 22.9258 11 22.9258H8C7.44772 22.9258 7 22.4781 7 21.9258V1.92578ZM0 6.92578C0 6.3735 0.447715 5.92578 1 5.92578H4C4.55228 5.92578 5 6.3735 5 6.92578V21.9258C5 22.4781 4.55228 22.9258 4 22.9258H1C0.447715 22.9258 0 22.4781 0 21.9258V6.92578ZM15 8.92578C14.4477 8.92578 14 9.3735 14 9.92578V21.9258C14 22.4781 14.4477 22.9258 15 22.9258H18C18.5523 22.9258 19 22.4781 19 21.9258V9.92578C19 9.3735 18.5523 8.92578 18 8.92578H15Z"
      fill={props.fill}
    />
  </svg>
);

export default BotonInfoGeneral;
